import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: any = {
    recaptcha: {
      siteKey: environment.recaptcha.siteKey,
    },
    sentryUrl: '',
  };

  async loadConfig() {
    try {
      const response = await fetch('/static/config/config.json');
      if (!response.ok) {
        console.warn(
          'Config file not found, using default values from environment'
        );
        return;
      }
      const config = await response.json();
      this.config = {
        ...this.config,
        ...config,
      };
    } catch (error) {
      console.warn(
        'Error loading config, using default values from environment:',
        error
      );
    }
  }

  getConfig(key: string) {
    return this.config[key];
  }

  getRecaptchaKey() {
    return this.config.recaptcha?.siteKey ?? environment.recaptcha.siteKey;
  }

  getSentryUrl() {
    return this.config.sentryUrl;
  }
}
